<template>
  <div>

    <Title title="九吨简介"></Title>
    <!-- 视频播放 -->
    <div class="video-wrapper">
      <div class="swiper3 ">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in list" :key="index">
            <img v-if="item.resourceType == 'image'" :src="item.resource" alt="" class="img">
            <div v-else class="video-box">
              <video :ref="`video_${index}`" :src="item.extends" class="video" :poster="item.resource" webkit-playsinline
                playsinline="true"> </video>
              <img src="@/assets/img/mobile/22.png" v-show="!item.playFlag" alt="" class="paly-icon"
                @click="play(`video_${index}`, index)">
            </div>
          </div>
        </div>
      </div>

    </div>


    <!-- 公司简介文案 -->
    <div class="desc-wrapper">
      <h1 class="title">
        重庆市九吨科技有限公司
      </h1>
      <!-- <h2 class="title-en">
        Chongqing Jiuton Technology Co., LTD
      </h2> -->
      <p class="desc">
        成立于2013年5月23日，从重庆大学计算机实验室里的三人团队，发展成为今天拥有400余人的成熟团队。

        <br>
        <br>
        九吨科技秉承着“<span>善良正直、务实担当、创新进取、追求极致</span>”的创业理念，打造了一家年轻有活力的科技型创新企业，团队成员平均年龄26岁，一直专注于移动互联网产品的自主研发和运营，在移动App矩阵、移动广告平台两大业务板块中，拥有四十余款核心产品，累计用户超过六亿，月活跃(MAU)用户超过两千万，是西南地区为数不多的用户量突破六亿大关的移动互联网公司。2017年成立了全资子公司，重庆赋比兴科技有限公司，后将九吨科技的业务全部转移至子公司中。

      </p>

    </div>
  </div>
</template>

<script>
import "swiper/js/swiper";
import "swiper/css/swiper.css";
import Swiper from "swiper";
import Title from '@/components/mobile/Title'
export default {
  components: { Title },
  data() {
    return {
      list: []
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    // 播放视频
    play(ref, index) {
      this.$refs[ref][0].play()
      this.list[index].playFlag = true
    },
    pause() {
      // 暂停所有视频播放
      for (const i in this.$refs) {
        if (i.indexOf('video_') > -1) {
          this.$refs[i][0].pause()
        }
      }
      for (const i of this.list) {
        i.playFlag = false
      }
    },
    async getData() {
      const [err, res] = await this.$http.get('culture')
      if (err) return
      for (const i of res.list) {
        i.playFlag = false
      }
      this.list = res.list

      this.$nextTick(() => {
        this.initSwiper();
      })
    },
    initSwiper() {
      const _this = this
      this.swiperExa = new Swiper(".swiper3", {
        // direction: "horizontal", // 垂直切换选项
        on: {
          // 当轮播切换的时候
          slideChange: function () {
            _this.pause()
          },
        }
      });
    }
  }

}
</script>

<style lang="less" scoped>
.video-wrapper {
  width: 8.7867rem;
  height: 5.0133rem;
  border-radius: .4rem;
  // background: #ddd;
  margin: 1.1467rem auto 1rem;
  overflow: hidden;
  .swiper3 {
    height: 100%;
  }

  .swiper-slide {

    // background: red;
    .img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .video-box {
      position: relative;

      .paly-icon {
        width: .88rem;
        height: .88rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .video {
      width: 100%;
      height: 100%;
      object-fit: fill;
      border-radius: .4rem;
    }
  }
}

.desc-wrapper {
  .title {
    font-weight: bold;
    font-size: .5333rem;
    // margin-bottom: .1333rem;
    margin-bottom: 1.0667rem;
    position: relative;
    &::after {
      content: "";
      width: .5733rem;
      height: .12rem;
      background: #F7931E;
      border-radius: .0667rem;
      position: absolute;
      left: 0;
      bottom: -0.2667rem;
    }
  }

  .title-en {
    color: #B2B2B2;
    font-size: .36rem;
    margin-bottom: 1.0667rem;
    position: relative;

    &::after {
      content: "";
      width: .5733rem;
      height: .12rem;
      background: #F7931E;
      border-radius: .0667rem;
      position: absolute;
      left: 0;
      bottom: -0.2667rem;
    }
  }

  .desc {
    color: #666;
    font-size: .2933rem;
    line-height: .5333rem;

    span {
      color: #F7931E;
    }
  }
}
</style>